import './suppressConsole';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async'; 
import Routing from './components/Routing';
import Chat from './components/chat';
import Footer from './components/footer';
import reportWebVitals from './reportWebVitals';
import './styles/main.css';
import { useTranslate } from './hooks/useTranslate';
import { I18nProvider } from './i18n.js';
import IndianAutoTranslate from './components/IndianAutoTranslate';

const GOOGLE_CLIENT_ID = "2743559538-g2pci5n6fh2aagi3grk3skpcavtkk919.apps.googleusercontent.com";

const App = () => {
  const getBrowserLanguage = () => {
    const browserLang = navigator.language.split('-')[0];
    const supportedLangs = ['en', 'de', 'zh', 'ru', 'ja', 'es', 'fr', 'hi', 'ta', 'bn'];
    return supportedLangs.includes(browserLang) ? browserLang : 'en';
  };

  const initialLocale = localStorage.getItem('locale') || getBrowserLanguage();
  const { t, tWithFallback, locale, changeLanguage } = useTranslate(initialLocale);

  return (
    <HelmetProvider> 
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>  
        <I18nProvider value={{ t, tWithFallback, locale, changeLanguage }}>
          <BrowserRouter
            future={{
              v7_startTransition: true,        // ✅ ADD
              v7_relativeSplatPath: true,       // ✅ ADD
            }}
          >
            <Toaster                            
              position="top-right"
              toastOptions={{
                success: {
                  duration: 4000,
                  style: { background: '#10b981', color: '#fff', padding: '16px', borderRadius: '10px', fontWeight: '500' },
                },
                error: {
                  duration: 5000,
                  style: { background: '#ef4444', color: '#fff', padding: '16px', borderRadius: '10px', fontWeight: '500' },
                },
                loading: {
                  style: { background: '#3b82f6', color: '#fff', padding: '16px', borderRadius: '10px' },
                },
              }}
            />
            <IndianAutoTranslate />
            <Routing />
            <Chat />
            <Footer />
          </BrowserRouter>
        </I18nProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
};

// ✅ Disable Grammarly globally across entire app
document.documentElement.setAttribute('data-gramm', 'false');
document.documentElement.setAttribute('data-enable-grammarly', 'false');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();